import { useEffect, useState } from 'react';
import { useNotificationProvider } from 'hooks';
import { ParkingLocation } from '../types/parkingLocation';
import { getParkingLocationsByCustomerId } from 'api/canpark/parkingLocations/getParkingLocationsByCustomerId';

export function useParkingLocations(customerId: string | null) {
	const [parkingLocations, setParkingLocations] = useState<ParkingLocation[]>(
		[],
	);
	const [loading, setLoading] = useState<boolean>(false);
	const { notifyError } = useNotificationProvider();

	// Load parking lots when the component mounts
	useEffect(() => {
		const loadParkingLocations = async () => {
			if (!customerId) return;
			try {
				setLoading(true);
				const locations = await getParkingLocationsByCustomerId(
					customerId,
				);
				setParkingLocations(locations);
			} catch (e) {
				notifyError('Error loading parking lots');
			} finally {
				setLoading(false);
			}
		};

		loadParkingLocations();
	}, [customerId, notifyError]);

	return { parkingLocations, setParkingLocations, loading };
}
